import React from 'react';

// Vertical milestone list for the mandate detail page.
// Each step has a dot marker (done / current / pending) and a connector line.

export interface TimelineStep {
  label: string;
  state: 'done' | 'current' | 'pending';
  date?: string; // human-readable (e.g. "2026-02-14")
}

interface Props {
  steps: TimelineStep[];
}

const Timeline = ({ steps }: Props) => (
  <div className="timeline">
    {steps.map((step, i) => {
      const nextDoneOrCurrent = step.state === 'done' || step.state === 'current';
      return (
        <div className="timeline-row" key={`${i}-${step.label}`}>
          <div className="timeline-marker">
            <div className={`dot ${step.state}`} />
            <div
              className={`line ${nextDoneOrCurrent && i < steps.length - 1 && steps[i + 1].state !== 'pending' ? 'done' : ''}`}
            />
          </div>
          <div className="timeline-body">
            <div className="label">
              {step.label}
              {step.state === 'current' && <span className="chip gold">Current</span>}
            </div>
            {step.date && <div className="meta">{step.date}</div>}
          </div>
        </div>
      );
    })}
  </div>
);

export default Timeline;
